// extracted by mini-css-extract-plugin
export default {"linha":"Home_linha__1aIrv","topo_bg":"Home_topo_bg__xCpa9","card":"Home_card__Bfus1","break":"Home_break__lN6hr","starfield":"Home_starfield__YqDRM"};